import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Chemistry.svg",
  "use": "Chemistry.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Chemistry.svg\"><path d=\"M40.04,27.78,51.4921,48.0318A4,4,0,0,1,48.008,54H15.9921a4,4,0,0,1-3.4841-5.9682L23.96,27.78a7.9978,7.9978,0,0,0,1.036-3.9366V12H24a2,2,0,1,1,0-4H40.0005a2,2,0,0,1,0,4h-.9968V23.8433A7.9968,7.9968,0,0,0,40.04,27.78ZM35,12H29V23.8434a12,12,0,0,1-1.5534,5.9047L25.4654,33.254a.5.5,0,0,0,.4351.746H38.1a.5.5,0,0,0,.4354-.746l-1.9817-3.5059A12,12,0,0,1,35,23.8434Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol